import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { PanelBody } from '../../../../components/designer/panels/PanelBody';
import * as Icon from '../../../../components/icons';
import InboxZero from '../../../../components/InboxZero';
import {
  InputAnswerGroup,
  InputQA,
  InputQuestion,
} from '../../../../components/inputs/InputQuestionAnswer';
import { ScreenTitle } from '../../../../components/layout/ScreenTitle';
import TitleSection from '../../../../components/layout/TitleSection';
import HelpContainer from '../../../../helpContext/HelpContainer';
import ConverterAisleOrderPanel from '../panels/ConverterAisleOrderPanel';
import { converterEditableArea } from '../store/converter.area.state';
import { converterAreaBuilder } from '../store/converter.state';

const StepOrderAisles: React.FC = () => {
  const { t } = useTranslation('designer');

  const area = useRecoilValue(converterEditableArea);
  const areaBuilder = useRecoilValue(converterAreaBuilder(area?.id));

  return (
    <PanelBody>
      <ScreenTitle
        isSticky
        subtitle={t`Setup Aisle`}
        title={t`Aisle Order`}
        helpNavTo={'designer/03-setup-aisles-order'}
      />
      <InputQA>
        <InputQuestion
          icon={Icon.DesignerAislesOrder}
          question={t`Are the aisles shown in the correct order on the map?`}
        />
        <InputAnswerGroup>
          <HelpContainer id={'designer/03-setup-aisles-order'} hasPadding />
        </InputAnswerGroup>

        <TitleSection className="mt-4" titleView title={t`Aisle Order Setup`} />
        {area && areaBuilder ? (
          <ConverterAisleOrderPanel area={area} />
        ) : (
          <InboxZero
            message={t`No Area Selected`}
            message_helper={t`Double-Click Area to edit Aisles, Bays or Locations`}
          />
        )}
      </InputQA>
    </PanelBody>
  );
};

export default StepOrderAisles;
